import { CircularProgress, Link } from '@mui/material'
import { downloadFileName } from 'controllers/documents/index.'
import { useState } from 'react'

interface DownloadFileNameLinkProps {
  disabled?: boolean
  fileName: string
  label: string
}

export default function DownloadFileNameLink({ disabled, fileName, label }: DownloadFileNameLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting) return

        setIsSubmitting(true)
        downloadFileName(fileName).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : label}
    </Link>
  )
}
